var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09053 9.00028L1.32135 3.2311L0.131628 2.04138C-0.0438766 1.86587 -0.0438766 1.58067 0.131628 1.40517L1.40461 0.132192C1.58011 -0.0433137 1.86531 -0.0433137 2.04081 0.132192L8.99972 7.0911L15.9586 0.131629C16.1341 -0.0438764 16.4193 -0.0438764 16.5948 0.131629L17.8684 1.40461C18.0439 1.58011 18.0439 1.86531 17.8684 2.04081L10.9089 9.00028L17.8684 15.9592C18.0439 16.1347 18.0439 16.4199 17.8684 16.5954L16.5954 17.8684C16.4199 18.0439 16.1347 18.0439 15.9592 17.8684L8.99972 10.9095L3.23054 16.6786L2.04081 17.8684C1.86531 18.0439 1.58011 18.0439 1.40461 17.8684L0.131628 16.5954C-0.0438766 16.4199 -0.0438766 16.1347 0.131628 15.9592L7.09053 9.00028Z",
    fill: "#A2A3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.6353621523b6b26434a31100293f1364.svg";
export { ForwardRef as ReactComponent };